import { FC, useContext } from "react";
import MButton from "components/momentum/MButton";
import GridEventProvider from "components/context/GridEventContext";

const ClearFilter: FC<{ ready: boolean }> = () => {
  const { gridEvent } = useContext(GridEventProvider);
  const onClick = () => {
    // will not reset quick filter
    const {
      externalFilter,
      externalTopFilter,
      externalAccountListFilter,
      externalHealthFilter,
      externalSearch,
      externalAlertFilter,
    } = gridEvent!.api.getFilterModel();
    gridEvent?.api.setFilterModel({
      externalFilter,
      externalTopFilter,
      externalAccountListFilter,
      externalHealthFilter,
      externalSearch,
      externalAlertFilter,
    });
  };

  return (
    <MButton
      onClick={onClick}
      trackName="Clear Filter"
    >
      Clear Filter
    </MButton>
  );
};

export default ClearFilter;
